<template>
  <div>
    <router-view></router-view>
  </div>
</template>


<script>
export default {
  name: 'DevelopAppdetailPage',
  components: {
  },
  data() {
    return {
    }
  },
  methods: {
  },
  created() {
    console.log('DevelopAppdetailPage created')
  },
  mounted() {
    console.log('DevelopAppdetailPage created')
  },
  beforeDestroy() {
    console.log('DevelopAppdetailPage beforeDestroy')
  }
}
</script>

